import * as React from "react";
import * as S from "@styled";
import { connect } from "react-redux";

import { DispatchType } from "../../shared/utilities";
import { updateLogResult } from "../actions/AddOrUpdateElement";
import { State } from "../model/State";
import CustomToggle from "shared/components/CustomToggle";

export const LogResultEditor: React.FC<LogResultEditorProps> = (props: LogResultEditorProps) => {

    return (
        <S.FormGroup $inline={true}>
            <S.Label>
                {props.label || FRENDS.Localizations.OmitResultAndParameters}
            </S.Label>
            <CustomToggle
                checked={props.shouldNotLogResult}
                onChange={props.onLogResultChange}
                disabled={props.disabled}
            />
        </S.FormGroup>
    )
};

interface LogResultEditorOwnProps {
    elementId: string | undefined;
    label?: string;
}

interface LogResultEditorStateProps {
    shouldNotLogResult: boolean;
    disabled?: boolean;
}

interface LogResultEditorDispatchProps {
    onLogResultChange: (checked: boolean, event: any, id: string,) => void;
}

export type LogResultEditorProps = LogResultEditorOwnProps & LogResultEditorStateProps & LogResultEditorDispatchProps;
const mapStateToProps = (state: State, ownProps: LogResultEditorProps): LogResultEditorStateProps => {
    const element = state.elements[ownProps.elementId as string];
    return {
        shouldNotLogResult: element && element.shouldNotLogResult || false,
        disabled: state.uiState.disableEdit
    };
};

const mapDispatchToProps = (dispatch: DispatchType<State>, ownProps: LogResultEditorOwnProps): LogResultEditorDispatchProps => {
    return {
        onLogResultChange: (checked: boolean, event: any, id: string) => dispatch(updateLogResult(ownProps.elementId, checked))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LogResultEditor);
